module.exports = __webpack_public_path__ + "static/media/image-card-3.93dd5bc6.png";